// extracted by mini-css-extract-plugin
export default {"container":"menu_container__lYjx7","items":"menu_items__7fu06","item":"menu_item__1_PsL"};